export class GiftDto {
    id!: string;
    price!: number;
}

export class OwnedGiftDto {
    id!: number;
    giftId!: string;
    text!: string;
    presenterId!: number;
    presenterName!: string;
    giftedAt!: string;
    textHidden!: boolean;
}

export class NewGiftsDto {
    count!: number;
    gift!: OwnedGiftDto;
}

export class GiftInfo {
    id!: number;
    giftId!: string;
}

export enum GiftCategory {
    FRUITS = 'FRUITS',
    NEW_YEAR = 'NEW_YEAR',
    VALENTINE = 'VALENTINE',
    FOOD = 'FOOD',
    ANIMALS = 'ANIMALS',
    EASTER = 'EASTER',
    SPRING = 'SPRING',
    KNOWLEDGE_DAY = 'KNOWLEDGE_DAY',
    HELLOWEEN = 'HELLOWEEN',
    WOMAN = 'WOMAN',
    BIRTHDAY = 'BIRTHDAY',
    NY_2025 = 'NY_2025'
}
